import { ICopyValidationState } from '../model/types'

interface IInitiativeWithEntryId {
  EntryId: number
}

export const getValidatedCopyInitiatives = <T extends IInitiativeWithEntryId>(
  initiatives: T[],
  validation: Record<number, ICopyValidationState>
): T[] => initiatives.filter((initiative) => validation[initiative.EntryId]?.status === 'valid')

export const isCopyValidationPending = <T extends IInitiativeWithEntryId>(
  initiatives: T[],
  validation: Record<number, ICopyValidationState>
): boolean =>
  initiatives.some((initiative) => {
    const status = validation[initiative.EntryId]?.status
    return status !== 'valid' && status !== 'invalid'
  })
